import {
    axiosJwt
} from '@/shared/auth/axios-lib'
import {
    errorHandler
} from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}/administracao`

export default {
    obterTodos() {
        return axiosJwt.get(`${api}/controleacesso/usuarios`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    obterPorId(id) {
        return axiosJwt.get(`${api}/controleacesso/usuarios/${id}`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    obterPorIdComPerfisAcesso(usuarioId) {
        return axiosJwt.get(`${api}/controleacesso/usuarios/${usuarioId}/perfisacesso`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    inserirUsuario(usuario) {
        return axiosJwt.post(`${api}/controleacesso/usuarios`, usuario)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    atualizarUsuario(usuario) {
        return axiosJwt.put(`${api}/controleacesso/usuarios`, usuario)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    associarPerfilAcesso(usuarioPerfilAcesso) {
        return axiosJwt.post(`${api}/controleacesso/usuarios/${usuarioPerfilAcesso.usuarioId}/perfilacesso`, usuarioPerfilAcesso)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    associarPerfisAcesso(usuarioPerfisAcesso) {
        return axiosJwt.post(`${api}/controleacesso/usuarios/${usuarioPerfisAcesso.usuarioId}/perfisacesso`, usuarioPerfisAcesso)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    desassociarPerfilAcesso(usuarioPerfilAcesso) {
        return axiosJwt.patch(`${api}/controleacesso/usuarios/${usuarioPerfilAcesso.usuarioId}/perfilacesso`, usuarioPerfilAcesso)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    desassociarPerfisAcesso(usuarioPerfisAcesso) {
        return axiosJwt.patch(`${api}/controleacesso/usuarios/${usuarioPerfisAcesso.usuarioId}/perfisacesso`, usuarioPerfisAcesso)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    ativarDesativarUsuario(usuarioId) {
        return axiosJwt.patch(`${api}/controleacesso/usuarios/${usuarioId}/ativardesativar`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    resetarSenhaUsuario(usuarioId) {
        return axiosJwt.patch(`${api}/controleacesso/usuarios/${usuarioId}/resetarsenha`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    trocarSenhaUsuario(usuarioId, trocaSenha) {
        return axiosJwt.patch(`${api}/controleacesso/usuarios/${usuarioId}/trocarsenha`, trocaSenha)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    pesquisarLoginAd(login) {
        return axiosJwt.get(`${api}/controleacesso/usuarios/ad/${login}`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    obterAtendentes() {
        return axiosJwt.get(`${api}/controleacesso/usuarios/atendentes`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    }
}
